import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/static/icons/close.svg'


const _hoisted_1 = { class: "size-dropdown__header" }
const _hoisted_2 = { class: "size-dropdown__header-title" }
const _hoisted_3 = { class: "size-dropdown__option-text" }

import { computed, inject, onMounted, ref, watch } from 'vue';

import useWindowResize from '@/composables/useWindowResize';
import useWebsiteTexts from '@/composables/useWebsiteTexts';
import useSizeDisplay from '@/composables/useSizeDisplay';

import Dropdown from '../forms/Dropdown.vue';
import SizeButton from './SizeButton.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SizeDropdown',
  setup(__props) {

const { isMobile } = useWindowResize();
const { websiteText } = useWebsiteTexts();
const { getSizeName } = useSizeDisplay();

const addToCartContext = inject('addToCartContext') as any;

const dropdownEl = ref<InstanceType<typeof Dropdown> | null>(null);
const isSizeDropwdownOpen = ref(false);
const selectedSize = ref<any>(addToCartContext?.selectedSize?.value || null);

const sizes = computed(() => addToCartContext.sizes.value || []);

const sizesValues = computed(() =>
  sizes.value.map((size: any) => ({
    value: size.systemId,
    text: size.sizeName,
    data: size,
    isSelected: selectedSize.value?.systemId === size.systemId,
  }))
);

const selectedSizeCaption = computed(() => {
  return getSizeName(selectedSize.value?.sizeName) || '';
});

watch(
  () => addToCartContext?.selectedSize?.value,
  (value) => {
    selectedSize.value = value;
  }
);

function selectSizeAndCloseOptions(sizeOption: any) {
  const sizeSystemId = sizeOption.value as string;
  const size = sizes.value.find((size: any) => size.systemId === sizeSystemId);
  addToCartContext.selectVariant(size);
  isSizeDropwdownOpen.value = false;
}

function closeDropdown() {
  dropdownEl.value?.closeDropdown();
}

function toggleSizeOverlay(isDropdownOpen: boolean) {
  isSizeDropwdownOpen.value = isDropdownOpen;

  if (isDropdownOpen && isMobile.value) {
    toggleElementAnimation(
      'size__slide-up',
      dropdownEl.value?.$refs?.dropdown as HTMLDivElement
    );
    const overlay = document.createElement('div');
    overlay.id = 'size-overlay';
    overlay.className = 'size__overlay';

    document.body.appendChild(overlay);
    document.body.classList.add('size__body-no-scroll');
  } else {
    toggleElementAnimation(
      'size__slide-down',
      dropdownEl.value?.$refs?.dropdown as HTMLDivElement
    );
    const overlay = document.getElementById('size-overlay');
    if (overlay) {
      overlay.remove();
      document.body.classList.remove('size__body-no-scroll');
    }
  }
}

function toggleElementAnimation(cssClass: string, element: HTMLElement) {
  if (element && isMobile.value) {
    requestAnimationFrame(() => {
      element.classList.add(cssClass);
      setTimeout(() => {
        element.classList.remove(cssClass);
      }, 1000);
    });
  }
}
onMounted(() => {
  selectedSize.value = addToCartContext?.selectedSize?.value;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Dropdown, {
    class: "size-dropdown",
    options: _unref(sizesValues),
    "v-model": selectedSize.value,
    onChange: selectSizeAndCloseOptions,
    onExpanded: toggleSizeOverlay,
    placeholder: _unref(selectedSizeCaption),
    ref_key: "dropdownEl",
    ref: dropdownEl
  }, {
    additionaloption: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, [
        _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(websiteText)('productdetails_choosesize').value), 1),
        _createElementVNode("img", {
          src: _imports_0,
          class: "size-dropdown__header-close",
          onClick: closeDropdown
        })
      ])
    ]),
    selected: _withCtx(() => [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(selectedSizeCaption)), 1)
    ]),
    option: _withCtx((slotProps) => [
      _createElementVNode("div", {
        class: _normalizeClass(["size-dropdown__option-text", {
          'size-dropdown__option-text--selected':
            slotProps?.option?.value === selectedSize.value?.value?.systemId,
        }])
      }, [
        _createVNode(SizeButton, {
          size: slotProps.option.data
        }, null, 8, ["size"])
      ], 2)
    ]),
    _: 1
  }, 8, ["options", "v-model", "placeholder"]))
}
}

})